// extracted by mini-css-extract-plugin
module.exports =  {"modal":"modal--LnUrk","modal-footer":"modal-footer--jjLyx","modalFooter":"modal-footer--jjLyx","button":"button--pxELX"};